/**
 * PaywallSuccessView - Success state after payment method update
 *
 * Shows confirmation message with link to dashboard.
 */

interface PaywallSuccessViewProps {
  onNavigateToDashboard: () => void;
}

export function PaywallSuccessView({ onNavigateToDashboard }: PaywallSuccessViewProps) {
  return (
    <div className="flex w-full flex-col items-center gap-6 py-8 text-center">
      {/* Success checkmark icon */}
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#0c6a58]">
        <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>

      {/* Success message */}
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-bold text-[#0A2540]">Payment Updated Successfully</h2>
        <p className="text-base text-gray-600">Your membership has been restored.</p>
      </div>

      {/* Dashboard button */}
      <button
        onClick={onNavigateToDashboard}
        className="mt-4 w-full max-w-xs rounded-xl bg-[#0c6a58] px-6 py-4 text-base font-semibold text-white transition-colors hover:bg-[#0a5a4a]"
      >
        Go to Dashboard
      </button>
    </div>
  );
}
